module.exports = __webpack_public_path__ + "static/28bfb38d0aeebc62dec6d9ffe38e67bd1304557a07f5af4fc86f09e41e3ad842-07044031dca39098bddfdc749a83b40f.png";